// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-data[data-v-ac227072]{height:100%;width:100%;background-color:#f0f0f0;color:#555;font-size:1.5em;font-weight:700;text-align:center}.custom-img[data-v-ac227072]{width:400px;height:400px}.v-carousel-item[data-v-ac227072]{background-color:#c8e6c9}.v-btn[data-v-ac227072]{background-color:#66bb6a;color:#fff}.v-btn[data-v-ac227072]:hover{background-color:#388e3c}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
